import React, { useEffect, useState } from 'react';
import { Card, CardContent, Typography } from '@mui/material';
import { tailoredApi } from '../../services/api';
import TailoredVersions from './TailoredVersions';

interface Props {
  applicationId: string;
  notify: (message: string, severity?: 'success' | 'error' | 'warning' | 'info') => void;
}

/** "Tailored for this job" on an application: shown only when a tailored resume was attached to it. */
const ApplicationTailored: React.FC<Props> = ({ applicationId, notify }) => {
  const [has, setHas] = useState(false);
  useEffect(() => {
    const controller = new AbortController();
    tailoredApi
      .list({ application: applicationId }, controller.signal)
      .then((versions) => setHas(versions.length > 0))
      .catch(() => {
        // An extra on this page; the page works without it.
      });
    return () => controller.abort();
  }, [applicationId]);

  if (!has) return null;
  return (
    <Card variant="outlined">
      <CardContent>
        <Typography variant="h6" fontWeight={600} gutterBottom>
          Resume tailored for this job
        </Typography>
        <TailoredVersions notify={notify} applicationId={applicationId} bare />
      </CardContent>
    </Card>
  );
};

export default ApplicationTailored;
